import { ApiResponse, type AppConfigDto } from '@/types/webapi';
import { IConfigService } from './IConfigService';
import { inject, injectable } from 'inversify';
import { AxiosInstance, IAxiosId } from '@/plugins/axios';

@injectable()
export class AppConfigService implements IConfigService {
    @inject(IAxiosId)
    protected axios: AxiosInstance;

    getConfig() {
        return new Promise<AppConfigDto>((resolve, reject) => {
            this.axios
                .get<ApiResponse<AppConfigDto>>('/api/v1.0/config')
                .then(response => resolve(response.data.data))
                .catch(reject);
        });
    }
}
